module.exports = __webpack_public_path__ + "static/media/saloon.1451206e.png";